import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { setPollutantPopupType, setAlertMessage } from '../../redux/user/user.actions';
import { selectPollutantPopupType } from '../../redux/user/user.selectors';

const PollutantPopup = ({ popupConfig, popupType, setPopupType, setAlertMessage }) => {
  const loadingMessage = '<div class="station-map-popup__message-container"><div class="station-map-popup__animation"></div><p class="station-map-popup__message">Retrieving pollutant description...</p></div>';
  const [ pollutantContent, setPollutantContent ] = useState("");
  const popupTypeLowercase = popupType.toLowerCase();

  useEffect( () => {
    // Hide the pollutant popup if was open on the last page refresh
    setPopupType("");
  }, []);

  useEffect( () => {
    switch (popupTypeLowercase) {
      case "pm2.5":
      case "pm2.5d":
        makePopupContentRequest(popupConfig.pm25Url);
        break;

      case "pm10":
        makePopupContentRequest(popupConfig.pm10Url);
        break;

      case "ozone":
        makePopupContentRequest(popupConfig.ozoneUrl);
        break;

      default:
        break;
    }
  }, [popupType]);

  function makePopupContentRequest(url) {
    // Show the loading message
    setPollutantContent(loadingMessage);

    getPopupContent(url)
    .then( (data) => {
      // Add the content to the popup
      setPollutantContent(data);
    })
    .catch( (evt) => {
      // Hide the loading message
      setPopupType("");

      setAlertMessage(`There has been a problem retrieving the pollutant description. Please try again later. Message: ${evt.message}`);
    });
  }

  async function getPopupContent(url) {
    let response = await fetch(url);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.text();
  }

  function createMarkup() {
    return {__html: pollutantContent};
  }

  /**
   * Respond to clicks on the popup close button
   *
   * @param {Click Event} evt Event that triggered the click
   *
   * @returns void
   */
  const onCloseButtonClick = (evt) => {
    evt.preventDefault();

    // Reset the popup
    setPopupType("");
  };

  return (
    <div>
      {
        (popupType !== "") ?
        <div className="station-map-popup__wrapper" role="region" aria-live="polite">
          <div className="station-map-popup__container">
            <div dangerouslySetInnerHTML={ createMarkup() } />
            <button onClick={onCloseButtonClick} className="station-map-popup__close-button">
              <span className="station-map-popup__close-bar"></span>
              <span className="station-map-popup__close-bar"></span>
              <span className="visuallyhidden">Close this popup</span>
            </button>
          </div>
        </div>
        : null
      }
    </div>
  );
};

PollutantPopup.propTypes = {
  "popupConfig": PropTypes.object,
  "popupType": PropTypes.string,
  "setPopupType": PropTypes.oneOfType( [PropTypes.string, PropTypes.func] ),
  "setAlertMessage": PropTypes.oneOfType( [PropTypes.string, PropTypes.func] ),
};

const mapStateToProps = (state) => {
  return {
    "popupType": selectPollutantPopupType(state)
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    "setPopupType": popupTypeId => dispatch(setPollutantPopupType(popupTypeId)),
    "setAlertMessage": message => dispatch(setAlertMessage(message))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PollutantPopup);